import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { currentTheme, toggleTheme } from "@/lib/theme";

// Small circular toggle used in the header.
// Reads DOM state on mount so it stays in sync if theme was set elsewhere.
export default function ThemeToggle({ className = "" }) {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    setTheme(currentTheme());
  }, []);

  const onClick = () => {
    const next = toggleTheme();
    setTheme(next);
  };

  return (
    <button
      onClick={onClick}
      aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
      data-testid="theme-toggle"
      className={`w-9 h-9 grid place-items-center border border-white/15 text-white/70 hover:text-white hover:border-white/30 transition-colors ${className}`}
    >
      {theme === "light" ? <Moon size={15} /> : <Sun size={15} />}
    </button>
  );
}
